import React, { useEffect } from 'react';
import { intercomScript } from 'utils/intercom-script';
import IntercomChatButton from './intercom-chat-button';

// Extend window interface for Intercom
declare global {
  interface Window {
    Intercom?: any;
    intercomSettings?: any;
  }
}

interface IntercomProviderProps {
  children: React.ReactNode;
}

const IntercomProvider: React.FC<IntercomProviderProps> = ({ children }) => {
  useEffect(() => {
    const initializeIntercom = () => {
      const appId = CONFIG.INTERCOM_APP_ID;

      if (!appId) {
        console.warn('Intercom App ID not configured');
        return;
      }

      // Load the Intercom script
      intercomScript();

      // Initialize Intercom with basic settings
      if (window.Intercom) {
        window.intercomSettings = {
          app_id: appId,
          hide_default_launcher: true,
          horizontal_padding: 95,
          vertical_padding: 40
        };

        window.Intercom('boot', window.intercomSettings);
        window.Intercom('update', { hide_default_launcher: true });

        // Hide the launcher when chat messenger is opened
        window.Intercom('onShow', () => {
          window.Intercom('update', { hide_default_launcher: true });
        });

        // Show the launcher when chat messenger is closed
        window.Intercom('onHide', () => {
          window.Intercom('update', { hide_default_launcher: false });
        });
      }
    };

    // Initialize Intercom when component mounts
    initializeIntercom();

    // Cleanup on unmount
    return () => {
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
    };
  }, []);

  const openIntercom = () => {
    if (window.Intercom) {
      window.Intercom('show');
    }
  };

  return (
    <>
      {children}
      <IntercomChatButton onClick={openIntercom} />
    </>
  );
};

export default IntercomProvider;
